import { createProxyUrl } from '@ocean/api'
import { localization } from '@ocean/configs'
import { ScreenType } from '@ocean/types'
import { Breadcrumb } from 'types'
import { EnvironmentUtils } from 'utils'
import requirementsRoutes from 'modules/requirements/Requirements/routing/routes'

const { i18n } = localization

class RequirementsUtils {
  random() {
    return Math.floor(Math.random() * 11)
  }

  getImageSource(rand: number, screenType: ScreenType) {
    const screenTypeParam = screenType === ScreenType.Mobile ? '&mobile=true' : ''
    return createProxyUrl(`requirementscontent?id=${rand}${screenTypeParam}`)
  }

  createRequirementsBreadcrumbs(breadcrumbs?: Breadcrumb[]) {
    const requirementsRoot = {
      id: 'REQUIREMENTS_ROOT',
      name: i18n.t('navigation.requirements'),
      pathname: requirementsRoutes.root,
    }
    if (!breadcrumbs?.length) return [requirementsRoot]
    return [requirementsRoot, ...breadcrumbs]
  }

  checkCesStartButtonVisibility() {
    const { allowToStartCesFromProficiency } = EnvironmentUtils.getPermissions('ces')
    return allowToStartCesFromProficiency
  }
}

export default new RequirementsUtils()
